import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
    loading: false,
    data:''
} 

export const GetWareHouseLocationList = createSlice({
    name: 'GetWareHouseLocationList',
    initialState,
    reducers: {
        initiateLoading: (state) => {
          state.loading = true
         },
        addSuccess: (state, action) => {
           state.loading = false;
            state.data = action.payload;
        },
        addFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload
        },
        resetData:(state,action)=>{
            state.loading = false;
            state.data = ''; 
        }
    }
});

export const { addSuccess, addFailure,initiateLoading,resetData} = GetWareHouseLocationList.actions;

// Selectors
export const getWareHouseLocationList = (state) => {
    return state.GetWareHouseLocationList;
};

export default GetWareHouseLocationList.reducer;
